import './styles.scss'

import { useTranslation } from 'react-i18next'
import { Col, Form, Input, Row } from 'antd'
import clsx from 'clsx'

import { useCheckoutContext } from '@/contexts/checkout/useCheckoutContext'

export default function ReferenceNumber() {
  const { t } = useTranslation()
  const { isOrderReferenceMandatory } = useCheckoutContext()

  const validateReferenceNumberField = () => {
    const maxLength = 35
    const rules = [
      {
        max: maxLength,
        message: t('errors.maxInputExceeded'),
      },
      {
        required: isOrderReferenceMandatory,
      },
    ]

    return rules
  }

  return (
    <Row className="payment-method__wrapper checkout-step1-section__wrapper">
      <Col lg={5} md={4} sm={24} xl={5} xs={24}>
        <h3
          className={clsx('checkout-step2__reference-number', {
            'mandatory-title': isOrderReferenceMandatory,
          })}
        >
          {t('checkout.step2.referenceNumber')}
        </h3>
      </Col>
      <Col lg={13} md={20} sm={24} xl={13} xs={24}>
        <Form.Item
          className="custom-form-item"
          initialValue=""
          name="referenceNumber"
          rules={validateReferenceNumberField()}
        >
          <Input placeholder={t('checkout.step2.referenceNumberPlaceholder')} />
        </Form.Item>
      </Col>
    </Row>
  )
}
